import http from '../interceptors/Intercepter';

export const retrieveQueryTypes = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/query-type/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewQueryType = async (username, externalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      externalReference: externalReference,
      username: username,
    };

    const { data } = await http.get('/api/query-type/view', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createQueryType = async (createQueryTypeRequest) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await http.post('/api/query-type/create', createQueryTypeRequest, { ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
